import { ExternalLink } from "lucide-react";
import { cn } from "@/lib/utils";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

interface EhrChipProps {
  /** The EHR link URL */
  url: string;
  /** Custom class name */
  className?: string;
}

/**
 * Compact external-link chip for linking to the Estonian Building Register (EHR).
 * Styled similarly to DocChip but with an external-link icon and blue tint.
 */
export function EhrChip({ url, className }: EhrChipProps) {
  return (
    <TooltipProvider delayDuration={300}>
      <Tooltip>
        <TooltipTrigger asChild>
          <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            className={cn(
              "not-prose",
              "inline-flex h-6 items-center gap-1.5 rounded px-2",
              "bg-blue-50 hover:bg-blue-100 active:bg-blue-200",
              "text-xs transition-colors",
              "focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-offset-1",
              className
            )}
          >
            <ExternalLink className="h-3.5 w-3.5 flex-shrink-0 text-blue-600" />
            <span className="text-neutral-600">Ehitisregister</span>
          </a>
        </TooltipTrigger>
        <TooltipContent side="top" className="max-w-xs">
          <p className="text-sm font-medium">Open in Ehitisregister</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
